module.exports = __webpack_public_path__ + "static/img/notext-startripx.1df3c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-startripx.png
// module id = E+sO
// module chunks = 1